import { render, staticRenderFns } from "./viewDoc.vue?vue&type=template&id=0916a4f0&scoped=true&"
import script from "./viewDoc.vue?vue&type=script&lang=js&"
export * from "./viewDoc.vue?vue&type=script&lang=js&"
import style0 from "./viewDoc.vue?vue&type=style&index=0&id=0916a4f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0916a4f0",
  null
  
)

export default component.exports